import { BoardParticipant, Partner, Society } from 'types';

export const getSelectablePartners = (
  society: Society,
  actualPartner: BoardParticipant
): Partner[] =>
  society?.partners.filter(
    (partner) => partner['_id'] === actualPartner?.representative
  ) || [];
